/* unplugin-vue-components disabled */import { render } from "./role.vue?vue&type=template&id=02f5dea0&scoped=true"
import script from "./role.vue?vue&type=script&setup=true&lang=js"
export * from "./role.vue?vue&type=script&setup=true&lang=js"

import "./role.vue?vue&type=style&index=0&id=02f5dea0&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f5dea0"],['__file',"src/pages/pulse/role.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02f5dea0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02f5dea0', __exports__)) {
    api.reload('02f5dea0', __exports__)
  }
  
  module.hot.accept("./role.vue?vue&type=template&id=02f5dea0&scoped=true", () => {
    api.rerender('02f5dea0', render)
  })

}


export default __exports__